import { AddDashboardFiltersParams, BuildDashboardContext } from './types';
import { manipulateDashboardFilters } from './dashboard-filters/manipulate-dashboard-filters';
import { devDebug } from '@/utils/dev-debug';

export const addDashboardFilters = async (
	{ dashboardId, userPrompt }: AddDashboardFiltersParams,
	context: BuildDashboardContext,
) => {
	const { dataSourceTitle, retrieveDashboard, saveDashboard, openAIClient } =
		context;
	devDebug('toolCall', {
		tool: 'addDashboardFilters',
		dashboardId,
		userPrompt,
		dataSourceTitle,
	});

	const currentDashboard = retrieveDashboard?.(dashboardId);
	if (!currentDashboard) {
		throw new Error('Dashboard not found');
	}

	const { dashboardProps: updatedDashboardProps, explanation } =
		await manipulateDashboardFilters(
			userPrompt,
			dataSourceTitle,
			currentDashboard,
			openAIClient,
		);

	saveDashboard?.(updatedDashboardProps);

	return {
		message: `${explanation} Click "Save" to persist changes to My Dashboards.`,
	};
};
